.input {
  border: 0;
  padding: 5px 6px;
  background-color: white;
  box-sizing: border-box;
  color: var(--button-text);
  border-right: 1px solid var(--field-border);
  text-align: right;
}
